import { Box } from '@mui/material';
import PropTypes from 'prop-types';

LoadingAnimationBase.propTypes = { wrapperSX: PropTypes.object, vid: PropTypes.string, vidmp4: PropTypes.string, poster: PropTypes.string };

export default function LoadingAnimationBase({ wrapperSX, vid, vidmp4, poster }) {
  return <Box sx={wrapperSX} display="flex" justifyContent="center">
    <video style={{ maxHeight: "400px", maxWidth: "550px" }} poster={poster} width="100%" height="100%" autoPlay muted loop playsInline>
      <source src={vidmp4} type="video/mp4;codecs=hvc1" />
      <source src={vid} type="video/webm" />
      Your browser does not support the video tag.
    </video>
  </Box>;
};
